import { ResponseError } from '@backstage/errors';














import { Method, ProxyFetch, PROXY_TARGETS } from './fetchProxyApi';
import { generateSearchParams } from './fetchGuard';





export class GluesManagement  {
  proxyFetch;

  constructor(options) {
    this.proxyFetch = new ProxyFetch({ 
      target: PROXY_TARGETS.devportal, 
      discoveryApi: options.discoveryApi
    });
  }

  // This function is for creating a glues variable.
  async insertGlue(params) {
    const res = await this.proxyFetch.fetchApi('v1/configurations/glues', {
      method: Method.POST,
      body: JSON.stringify({
        service_id: params.serviceId,
        cluster: {
          id: params.cluster.id,
          project: params.cluster.project,
          env: params.cluster.env,
          customer: params.cluster.customer,
          aws_assumable_role: params.cluster.awsAssumableRole,
          region: params.cluster.region,
          account_id: params.cluster.accountId,
        },
        type: params.type,
        name: params.name,
        value: params.value,
      }),
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  // This function is for updating glue variable.
  async updateGlue(id, params) {
    const { name, value, ...extraParams } = params
    const res = await this.proxyFetch.fetchApi(`v1/configurations/glues/${id}?${generateSearchParams(extraParams)}`, {
      method: Method.PUT,
      body: JSON.stringify({
        name,
        value,
      })
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  // This function is for deleting glue variable.
  async deleteGlue(id, params) {
    const res = await this.proxyFetch.fetchApi(`v1/configurations/glues/${id}?${generateSearchParams(params)}`, {
      method: Method.DELETE,
    });

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  // This function is for retrieving cluster information object using glues id
  async fetchGlue(id, params) {
    const res = await this.proxyFetch.fetchApi(
      `/v1/configurations/glues/${id}?${generateSearchParams(params)}`, 
      {
        method: Method.GET
      }
    );

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  // This function is for retrieving glues that belong to a certain service in a certain cluster using service_id and cluster_id
  async fetchGlueByServiceAndCluster(params) {
    const { account_id, serviceId, customer_name, project_name, environment_name, region } = params;
    const res = await this.proxyFetch.fetchApi(
      `gluemanagement/v1/accounts/${account_id}/customers/${customer_name}/projects/${project_name}/environments/${environment_name}/services/${serviceId}/glues?region=${region}`,
      {
        method: Method.GET
      }
    );

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }

  // This function is for retrieving glues parameters by cluster
  async fetchGlueParametersByCluster(params) {
    const { clusterId, start, ...extraParams } = params;
    const startQuery = start && `&start=${start}`; // separate this to avoid encoded by generateSearchParams helpers
    const res = await this.proxyFetch.fetchApi(
      `v1/configurations/glues/cluster/${clusterId}/parameters?${generateSearchParams(extraParams)}${startQuery || ''}`, 
      {
        method: Method.GET
      }
    );

    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }

    const data = await res.json();
    return data;
  }
}